import {
  RtFraction,
  RtWithName,
  RtWithProjectionPeriods,
  RtWithValue,
} from "@aprao/common/src/runtypes/common.js";
import { z } from "zod";

import { WithTimelineOverrideSchema } from "./TimelineStageSchema.js";

export const RtBuildPreliminary = z
  .object({
    costs: z.array(RtWithValue(RtFraction).merge(RtWithName)),
  })
  .merge(RtWithProjectionPeriods)
  .merge(WithTimelineOverrideSchema);
